import {
  getTicketsData,
  updateTicketsStatusData,
  downloadTicketsData,
  getTicketsUsedByAdminData,
  getTicketRefundData,
  refundExtraPayTicketBizmeshiData
} from '../libs/apis/TicketApi';

export const GET_TICKETS_REQUEST = 'GET_TICKETS_REQUEST';
export const GET_TICKETS_SUCCESS = 'GET_TICKETS_SUCCESS';
export const GET_TICKETS_FAILURE = 'GET_TICKETS_FAILURE';

export const GET_TICKETS_USED_BY_ADMIN_REQUEST =
  'GET_TICKETS_USED_BY_ADMIN_REQUEST';
export const GET_TICKETS_USED_BY_ADMIN_SUCCESS =
  'GET_TICKETS_USED_BY_ADMIN_SUCCESS';
export const GET_TICKETS_USED_BY_ADMIN_FAILURE =
  'GET_TICKETS_USED_BY_ADMIN_FAILURE';

export const UPDATE_TICKETS_STATUS_REQUEST = 'UPDATE_TICKETS_STATUS_REQUEST';
export const UPDATE_TICKETS_STATUS_SUCCESS = 'UPDATE_TICKETS_STATUS_SUCCESS';
export const UPDATE_TICKETS_STATUS_FAILURE = 'UPDATE_TICKETS_STATUS_FAILURE';

export const DOWNLOAD_TICKETS_REQUEST = 'DOWNLOAD_TICKETS_REQUEST';
export const DOWNLOAD_TICKETS_SUCCESS = 'DOWNLOAD_TICKETS_SUCCESS';
export const DOWNLOAD_TICKETS_FAILURE = 'DOWNLOAD_TICKETS_FAILURE';

export const GET_TICKET_REFUND_REQUEST = 'GET_TICKET_REFUND_REQUEST';
export const GET_TICKET_REFUND_SUCCESS = 'GET_TICKET_REFUND_SUCCESS';
export const GET_TICKET_REFUND_FAILURE = 'GET_TICKET_REFUND_FAILURE';

export const REFUND_EXTRA_PAY_TICKET_BIZMESHI_REQUEST =
  'GET_TICKET_REFUNDREFUND_EXTRA_PAY_TICKET_BIZMESHI_REQUEST';
export const REFUND_EXTRA_PAY_TICKET_BIZMESHI_SUCCESS =
  'REFUND_EXTRA_PAY_TICKET_BIZMESHI_SUCCESS';
export const REFUND_EXTRA_PAY_TICKET_BIZMESHI_FAILURE =
  'REFUND_EXTRA_PAY_TICKET_BIZMESHI_FAILURE';

export const downloadTickets = params => dispatch => {
  dispatch({ type: DOWNLOAD_TICKETS_REQUEST });
  return downloadTicketsData(params)
    .then(response =>
      dispatch({
        type: DOWNLOAD_TICKETS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DOWNLOAD_TICKETS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const downloadTicketsUsedByAdmin = params => dispatch => {
  dispatch({ type: DOWNLOAD_TICKETS_REQUEST });
  return downloadTicketsUsedByAdmin(params)
    .then(response =>
      dispatch({
        type: DOWNLOAD_TICKETS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DOWNLOAD_TICKETS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getTickets = params => dispatch => {
  dispatch({ type: GET_TICKETS_REQUEST });
  return getTicketsData(params)
    .then(response =>
      dispatch({
        type: GET_TICKETS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_TICKETS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getTicketsUsedByAdmin = params => dispatch => {
  dispatch({ type: GET_TICKETS_USED_BY_ADMIN_REQUEST });
  return getTicketsUsedByAdminData(params)
    .then(response =>
      dispatch({
        type: GET_TICKETS_USED_BY_ADMIN_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_TICKETS_USED_BY_ADMIN_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const updateTicketsStatus = params => dispatch => {
  dispatch({ type: UPDATE_TICKETS_STATUS_REQUEST });
  return updateTicketsStatusData(params)
    .then(response =>
      dispatch({
        type: UPDATE_TICKETS_STATUS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: UPDATE_TICKETS_STATUS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getTicketRefund = params => dispatch => {
  dispatch({ type: GET_TICKET_REFUND_REQUEST });
  return getTicketRefundData(params)
    .then(response =>
      dispatch({
        type: GET_TICKET_REFUND_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_TICKET_REFUND_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const refundExtraPayTicketBizmeshi = params => dispatch => {
  dispatch({ type: REFUND_EXTRA_PAY_TICKET_BIZMESHI_REQUEST });
  return refundExtraPayTicketBizmeshiData(params)
    .then(response =>
      dispatch({
        type: REFUND_EXTRA_PAY_TICKET_BIZMESHI_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: REFUND_EXTRA_PAY_TICKET_BIZMESHI_FAILURE,
        payload: error.response,
        error: true
      })
    );
};
